import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAdUnitPath = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M38.3 42q-2.05 0-3.575-1.225Q33.2 39.55 32.8 37.8H22.15q-3.3 0-5.475-2.175T14.5 30.15q0-3.3 2.175-5.475T22.15 22.5H26q2.05 0 3.35-1.3 1.3-1.3 1.3-3.35t-1.3-3.35q-1.3-1.3-3.35-1.3H15.2q-.45 1.75-1.95 2.975T9.7 17.4q-2.4 0-4.05-1.65T4 11.7q0-2.4 1.65-4.05T9.7 6q2.05 0 3.55 1.225T15.2 10.2H26q3.3 0 5.475 2.175t2.175 5.475q0 3.3-2.175 5.475T26 25.5h-3.85q-2.05 0-3.35 1.3-1.3 1.3-1.3 3.35t1.3 3.35q1.3 1.3 3.35 1.3H32.8q.45-1.75 1.95-2.975T38.3 30.6q2.4 0 4.05 1.65T44 36.3q0 2.4-1.65 4.05T38.3 42ZM9.7 14.4q1.15 0 1.925-.775.775-.775.775-1.925t-.775-1.925Q10.85 9 9.7 9t-1.925.775Q7 10.55 7 11.7t.775 1.925q.775.775 1.925.775Z" })
});
export default SvgAdUnitPath;
